<template>
    <div class="content-wrapper">
        <div class="content-body">
          <div class="d-flex justify-content-between">
            <h3 class="mt-50">Permissions Dashboard.</h3>
          </div>
          <div class="d-flex justify-content-between">
            <div class="flex-wrap form-group">
              <input type="text" class="form-control" placeholder="Search here" v-model="searchVal" @keyup="searchPermissions"/>
            </div>
            <div class="dt-buttons btn-group flex-wrap">
                <button
                    class="btn add-new btn-primary mt-50 mb-50"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#addPermissionModal"
                >
                    <span>Add Permission</span>
                </button>
            </div>
          </div>

            <div class="card">
                <div class="card-datatable table-responsive" style="background-color:f8f8f8;">
                    <div
                        id="DataTables_Table_0_wrapper"
                        class="dataTables_wrapper dt-bootstrap5 no-footer"
                    >
                        <div
                            class="d-flex justify-content-between align-items-center header-actions text-nowrap mx-1 row mt-75"
                        >
                            <div
                                class="col-sm-12 col-lg-4 d-flex justify-content-center justify-content-lg-start"
                            >

                            </div>
                        </div>
                        <div class="text-nowrap">
                            <vue-good-table
                                mode="remote"
                                v-on:page-change="onPageChange"
                                v-on:per-page-change="onPerPageChange"
                                :totalRows="totalRecords"
                                :pagination-options="{
                                    enabled: true,
                                    perPageDropdown: [10, 20, 30, 40, 50, 100],
                                    dropdownAllowAll: false,
                                }"
                                :rows="rows" :columns="columns"
                                :sort-options="{
                                    enabled: false
                                }"
                            >
                            <template #table-row="props">

                                <span v-if="props.column.field == 'name_display_name'">
                                    <div class="text-sm text-primary text-bold">{{props.row.name_display_name.display_name}}</div>
                                    <div class="text-sm">{{props.row.name_display_name.name}}</div>
                                    <!-- <div v-for="(user,index) in props.row.name_display_name" :key="index">
                                        <div class="text-sm">{{props.row.name_display_name.name}}</div>
                                    </div> -->
                                </span>

                                <span v-if="props.column.field == 'assigned_to'" class="d-flex">
                                    <div v-for="(assigned,index) in props.row.assigned_to" :key="index" >

                                        <span v-if="assigned=='diy_user'" class="badge rounded-pill badge-light-info text-sm" style="margin-right: 7px;">
                                            {{assigned}}
                                        </span>
                                        <span v-else-if="assigned=='author'" class="badge rounded-pill badge-light-info text-sm" style="margin-right: 7px;">
                                            {{assigned}}
                                        </span>
                                        <span v-else-if="assigned=='super_admin'" class="badge rounded-pill badge-light-primary text-sm" style="margin-right: 7px;">
                                            {{assigned}}
                                        </span>
                                        <span v-else-if="assigned=='client'" class="badge rounded-pill badge-light-success text-sm" style="margin-right: 7px;">
                                            {{assigned}}
                                        </span>
                                        <span v-else-if="assigned=='team_admin'" class="badge rounded-pill badge-light-danger text-sm" style="margin-right: 7px;">
                                            {{assigned}}
                                        </span>
                                        <span v-else-if="assigned=='business_user'" class="badge rounded-pill badge-light-warning text-sm" style="margin-right: 7px;">
                                            {{assigned}}
                                        </span>
                                        <span v-else class="badge rounded-pill badge-light-dark text-sm" style="margin-right: 7px;">
                                            {{assigned}}
                                        </span>

                                    </div>
                                    <!-- <span v-html="props.row.assigned_to"></span> -->
                                </span>
                                <span v-if="props.column.field == 'permission_date'">
                                    <span class="text-sm">
                                        {{props.formattedRow[props.column.field]}}
                                    </span>
                                </span>
                                <span v-if="props.column.field == 'actions'">
                                    <a class="btn btn-sm btn-icon text-black" :href="'/rbac/permissions/'+props.row.id">
                                        <vue-feather type="eye" style="width:17px;height:17px;"></vue-feather>
                                    </a>
                                    <button class="btn btn-sm btn-icon waves-effect waves-float waves-light" data-bs-toggle="modal" data-bs-target="#editPermissionModal" @click="editRow(event,props.row.id)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit font-medium-2 text-body"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" data-v-f1ea3c4a=""></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" data-v-f1ea3c4a=""></path></svg>
                                    </button>
                                    <button class="btn btn-sm btn-icon waves-effect waves-float waves-light" @click="showDelete(event,props.row.id,props.row.name)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash font-medium-2 text-body" data-v-f1ea3c4a="" ><polyline points="3 6 5 6 21 6" data-v-f1ea3c4a=""></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" data-v-f1ea3c4a=""></path></svg>
                                    </button>

                                </span>
                                <span v-else>
                                <!-- {{props.row.name}} -->
                                </span>
                            </template>
                            </vue-good-table>
                        </div>

                    </div>
                </div>
            </div>
            <!--/ Permission Table -->

            <!-- Add Permission Modal -->
            <div
                class="modal fade"
                id="addPermissionModal"
                tabindex="-1"
                aria-hidden="true"
            >
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header bg-transparent">
                            <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div class="modal-body px-sm-5 pb-5">
                            <div class="text-center mb-2">
                                <h1 class="mb-1">Add New Permission</h1>
                                <p>
                                    Permissions you may use and assign to your
                                    users.
                                </p>
                            </div>
                            <form
                                id="addPermissionForm"
                                class="row"
                                onsubmit="return false"
                                novalidate="novalidate"
                            >
                                <div class="col-6">
                                    <label
                                        class="form-label"
                                        for="modalPermissionName"
                                        >Permission Name</label
                                    >
                                    <input
                                        type="text"
                                        id="modalPermissionName"
                                        name="name"
                                        class="form-control"
                                        placeholder="Permission Name"
                                        autofocus=""
                                        data-msg="Please enter permission name"
                                        v-model="permissionName"
                                    />
                                </div>
                                <div class="col-sm-6">
                                    <label
                                        class="form-label"
                                        for="display_name"
                                        >Display Name</label
                                    >
                                    <input
                                        type="text"
                                        id="displayname"
                                        name="display_name"
                                        class="form-control"
                                        placeholder="Display Name"
                                        tabindex="-1"
                                        data-msg="Please enter a display name"
                                        v-model="permissionDisplayName"
                                    />
                                </div>
                                <div class="col-12 mt-75">
                                    <label
                                        class="form-label"
                                        for="editPermissionName"
                                        >Permission Type</label
                                    >
                                    <select
                                        id="permission_type"
                                        name="permission_type"
                                        class="form-control"
                                        placeholder="Enter a permission name"
                                        tabindex="-1"
                                        data-msg="Please enter permission type"
                                        v-model="permissionAddType"
                                    >
                                      <option v-for="(type, index) in permissiontype" :key="index" :value="type.permission_type">
                                          {{type.permission_type}}
                                      </option>
                                    </select>
                                </div>
                                <div class="col-md-12 col-12 mb-1">
                                    <label for="description">Description</label>
                                    <textarea class="form-control" id="description" name="description" rows="3" placeholder="Description" v-model="permissionDetail"></textarea>
                                </div>
                                <div class="col-12 text-center">
                                    <button
                                        type="submit"
                                        class="btn btn-primary mt-2 me-1 waves-effect waves-float waves-light"
                                        v-on:click="createPermission"
                                    >
                                        Create Permission
                                    </button>
                                    <button
                                        type="reset"
                                        class="btn btn-outline-secondary mt-2 waves-effect"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        ref="hidder"
                                    >
                                        Discard
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <!--/ Add Permission Modal -->
            <!-- Edit Permission Modal -->
            <div
                class="modal fade"
                id="editPermissionModal"
                tabindex="-1"
                aria-hidden="true"
            >
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header bg-transparent">
                            <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div class="modal-body p-3 pt-0">
                            <div class="text-center mb-2">
                                <h1 class="mb-1">Edit Permission</h1>
                                <p>Edit permission as per your requirements.</p>
                            </div>

                            <div class="alert alert-warning" role="alert">
                                <h6 class="alert-heading">Warning!</h6>
                                <div class="alert-body">
                                    By editing the permission name, you might
                                    break the system permissions functionality.
                                    Please ensure you're absolutely certain
                                    before proceeding.
                                </div>
                            </div>

                            <form
                                id="editPermissionForm"
                                class="row"
                                onsubmit="return false"
                                novalidate="novalidate"
                            >
                                <div class="col-12">
                                    <label
                                        class="form-label"
                                        for="editPermissionName"
                                        >Permission Name</label
                                    >
                                    <input
                                        type="text"
                                        id="editPermissionName"
                                        name="editPermissionName"
                                        class="form-control"
                                        placeholder="Enter a permission name"
                                        tabindex="-1"
                                        data-msg="Please enter permission name"
                                        v-model="permission.name"
                                    />
                                </div>
                                <div class="col-12">
                                    <label
                                        class="form-label"
                                        for="permission display name"
                                        >Display Name</label
                                    >
                                    <input
                                        type="text"
                                        id="display_name"
                                        name="display_name"
                                        class="form-control"
                                        placeholder="Enter a permission display name"
                                        tabindex="-1"
                                        data-msg="Please enter permission display name"
                                        v-model="permission.display_name"
                                    />
                                </div>
                                <div class="col-12 mt-75">
                                    <label
                                        class="form-label"
                                        for="editPermissionName"
                                        >Permission Type</label
                                    >
                                    <select
                                        id="permission_type"
                                        name="permission_type"
                                        class="form-control"
                                        placeholder="Enter a permission name"
                                        tabindex="-1"
                                        data-msg="Please enter permission type"
                                        v-model="permType.permission_type"
                                    >
                                        <option v-for="(type, index) in permissiontype" :key="index" :value="type.permission_type">
                                            {{type.permission_type}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-12 mt-75">
                                    <label
                                        class="form-label"
                                        for="editPermissionName"
                                        >Permission Description</label
                                    >
                                    <textarea
                                    class="form-control"
                                    id="description"
                                    name="description"
                                    rows="3"
                                    placeholder="Description"
                                    v-model="permission.description"
                                    ></textarea>
                                </div>
                                <div class="col-sm-12 b-flex justify-content-between">
                                    <button
                                        type="reset"
                                        class="btn btn-outline-secondary mt-2 mr-1 waves-effect"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        ref="hidePermissionUpdate"
                                    >
                                        Discard
                                    </button>
                                    <button
                                        type="submit"
                                        class="btn btn-primary mt-2 waves-effect waves-float waves-light"
                                        v-on:click="updatePermission"
                                    >
                                        Update
                                    </button>
                                </div>


                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <!--/ Edit Permission Modal -->
            <!-- delete permission Modal-->
            <div id="sweetAlertDelete" class="swal2-container swal2-center swal2-backdrop-show" style="overflow-y: auto;" v-if="showDeleteDialog" ref="closeDeleter">
                <div aria-labelledby="swal2-title" aria-describedby="swal2-html-container" class="swal2-popup swal2-modal swal2-icon-warning swal2-show" tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: grid;">
                    <button type="button" class="swal2-close" style="display: none;" aria-label="Close this dialog">×</button>
                    <ul class="swal2-progress-steps" style="display: none;"></ul>
                        <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
                            <div class="swal2-icon-content">!</div>
                        </div>
                        <img class="swal2-image" style="display: none;">
                        <h2 class="swal2-title" id="swal2-title" style="display: block;">
                            Are you sure ?
                        </h2>
                        <div class="swal2-html-container" style="display: block;">
                            You won't be able to revert {{deleteName}}!
                        </div>
                        <input class="swal2-input" style="display: none;">
                        <input type="file" class="swal2-file" style="display: none;">
                        <div class="swal2-range" style="display: none;">
                            <input type="range">
                            <output></output>
                        </div>
                        <select class="swal2-select" style="display: none;"></select>
                        <div class="swal2-radio" style="display: none;"></div>
                        <label for="swal2-checkbox" class="swal2-checkbox" style="display: none;">
                            <input type="checkbox">
                            <span class="swal2-label"></span>
                        </label>
                        <textarea class="swal2-textarea" style="display: none;"></textarea>
                        <div class="swal2-validation-message" id="swal2-validation-message" style="display: none;"></div>
                        <div class="swal2-actions">
                            <div class="swal2-loader"></div>
                            <button type="button" class="swal2-confirm btn btn-primary" style="display: inline-block;" aria-label="" v-on:click="deletePermission(permission_id)">Yes, delete it!</button>
                            <button type="button" class="swal2-deny mr-10" style="display: none;" aria-label="">No</button>&nbsp;&nbsp;&nbsp;
                            <button type="button" class="swal2-cancel btn btn-outline-danger ms-1" style="display: inline-block;" aria-label="sweetAlertDelete" v-on:click="hideDeleteModel">Cancel</button>
                        </div>
                        <div class="swal2-footer" style="display: none;"></div>
                        <div class="swal2-timer-progress-bar-container">
                        <div class="swal2-timer-progress-bar" style="display: none;"></div>
                    </div>
                </div>
            </div>
            <!-- end delete permission Modal -->
        </div>
    </div>
</template>
<script>
import 'vue-good-table-next/dist/vue-good-table-next.css'
import { VueGoodTable } from 'vue-good-table-next';
import axios from 'axios';
import {ref} from 'vue'
export default {
    name:'PermissionComponent',
    title:'Permissions',
    components: {
        VueGoodTable,
    },
    data() {
        return {
            permissionName:'',
            permissionDisplayName:'',
            permissionDetail:'',
            permissions:[],
            permission:'',
            permType:'',
            permission_id:'',
            permissiontype:[],
            searchVal:'',
            permissionAddType:'',
            showDeleteDialog:false,
            searchLink:'',
            permissionsData:[],
            currentPage:'',
            limit:10,
            totalRecords:'',
            columns: [
                        {
                        label: 'Name',
                        field: 'name_display_name',
                        // html:true
                        },
                        {
                        label: 'Assigned To',
                        field: 'assigned_to',
                        html:true
                        },
                        {
                        label: 'Created At',
                        field: 'permission_date',
                        html:true
                        },
                        {
                        label: 'Actions',
                        field: 'actions',
                        html:true
                        }
                    ],
            rows: [
                {
                    id:1,
                    name_display_name:"",
                    assigned_to:"",
                    permission_date: "",
                    actions:'',
                },

            ],
        };
    },
    setup(){
        return{
            hidder:ref(),
            hidePermissionUpdate:ref(),
        }
    },
    created(){
        this.getPermissionType();
        this.currentPage = `${baseUrl}/rbac/permissions/list`;
        this.getPermissionsList(this.currentPage,null);
    },
    methods:{
        getPermissionType(){
            axios.get(`${baseUrl}/rbac/permissions/permissiontype`).then(response => {
                this.permissiontype =response.data.data;
            });
        },
        createPermission(){
            let data = {
                name:this.permissionName,
                display_name:this.permissionDisplayName,
                description:this.permissionDetail,
                permission_type:this.permissionAddType
            };
            if(this.permissionName !== ""){
                axios.post(`${baseUrl}/rbac/permissions`,data).then((data)=>{
                    toastr.success('permission addedd successfully','success')
                    this.hidder.click();
                    this.getPermissionsList(this.currentPage,true)
                }).catch((error)=>{
                    toastr.error(error.message,'error')
                })
            }else{
                toastr.error('The Permission name can not be empty','error')
            }

        },
        getPermissionsList(uri, page) {
            let url;
            if (page == null || page == undefined) {
                url = uri + '?page=1&limit=' + this.limit;
            } else {
                url = uri + '&limit=' + this.limit
            }
            this.currentPage = url
            axios.get(url).then(({ data }) => {
                this.permissionsData = data.data.data
                this.totalRecords = this.permissionsData.total;
                this.rows = this.permissionsData.data
                this.permissions = this.rows;

            }).catch();
        },
        deletePermission(id){
            this.showDeleteDialog=true
            axios.delete(`${baseUrl}/rbac/permissions/${id}`).then(({data}) => {

                if(data.error == false){
                    toastr.success(data.message,'success')
                    this.hideDeleteModel();
                    this.getPermissionsList(this.currentPage,true)
                }else{
                    toastr.error(data.message,'error')
                }

            });
        },
        showDelete(e,id,name){
            this.showDeleteDialog=true;
            this.permission_id = id;
            this.deleteName = name;
        },
        hideDeleteModel(){
            this.showDeleteDialog=false;
        },
        editRow(event,id){
            this.permission_id=id;
            axios.get(`${baseUrl}/rbac/permissions/${id}/edit`).then(({data}) => {
                var data = data.data;
                this.permission = data.permission;
                if(data.permType == null){
                    this.permType = {
                        created_at: "",
                        id: 0,
                        permission_type: "",
                        updated_at: ""
                    }
                }else{
                    this.permType = data.permType;
                }
                this.permissiontype = data.permissiontype;
            }).catch(error=>{
                toastr.error('An error occurd, please try again','error')
            })
        },
        updatePermission(){
            let data={
                name:this.permission.name,
                display_name:this.permission.display_name,
                description:this.permission.description,
                permission_type:this.permType.permission_type
            }
            axios.put(`${baseUrl}/rbac/permissions/${this.permission_id}`,data).then(({data}) => {

                if(data.message =="success"){
                    toastr.success('Role updated successfully','success')
                    this.hidePermissionUpdate.click();
                    this.getPermissionsList(this.currentPage,true)
                }else{
                    toastr.error('Role not updated','error')
                }
            }).catch(error=>{
                toastr.error('Role not updated','error')
            })
        },
        searchPermissions() {
            let url;
            let usersSearchuri = `${baseUrl}/rbac/permissions/search`;
            if(this.searchLink == "" || this.searchLink == null || this.searchLink == undefined){
                url = usersSearchuri + '?page=1&limit=' + this.limit
            }else{
                url = this.searchLink + '&limit='+this.limit;
            }
            if (this.searchVal != "") {
                axios.get(`${url}&searchTerm=${this.searchVal}`).then(({ data }) => {
                    if (data.data != null) {
                        this.permissionsData = data.data.data
                        this.totalRecords = this.permissionsData.total;
                        this.rows = this.permissionsData.data
                        this.permissions = this.rows;
                    } else {
                        this.getPermissionsList(this.currentPage,true)
                    }
                })
                .catch(({ response })=>{
                    toastr.error(response.message, 'error!');
                })
            } else {
                this.searchLink = ""
                this.getPermissionsList(this.currentPage,true)
            }
        },
        onPageChange(params) {
            var global_data = this.permissionsData;
            if (params.prevPage < params.currentPage) {
                this.currentPage = global_data.next_page_url;
                if(this.searchVal != ""){
                    this.searchLink = global_data.next_page_url
                    this.searchPermissions();
                }else{
                    this.getPermissionsList(global_data.next_page_url, true);
                }
                
            } else {
                this.currentPage = global_data.prev_page_url;
                if(this.searchVal != ""){
                    this.searchLink = global_data.prev_page_url
                    this.searchPermissions();
                }else{
                    this.getPermissionsList(global_data.prev_page_url, true);
                }
            }
        },
        onPerPageChange(params) {
            let global_data = this.permissionsData;
            let links = global_data.links, activeLink,
            uri = `${baseUrl}/rbac/permissions/list`;
            links.forEach(element => {
                if (element.active == true) {
                    activeLink = element.url
                } else {
                    activeLink = uri + "?page=1"
                }
            });
            this.limit = params.currentPerPage;
            if(this.searchVal != ""){
                if(global_data.prev_page_url != null){
                    this.searchLink = global_data.prev_page_url
                }
                this.searchPermissions();
            }else{
                this.getPermissionsList(activeLink, true);
            }
        }


    }
};
</script>
<style scoped>
.form-select {
    padding: 0.571rem 1rem !important;
    background-size: 15px 14px !important;
}
.me-1 {
    margin-right: 1rem !important;
}
.roleselect {
    width: 100% !important;
}
</style>
